const roundedOverallRatingScore = (rating_score) => {
  if (rating_score) {
    return Math.round(rating_score);
  } else {
    return 0;
  }
}

export {
    roundedOverallRatingScore
}